import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <>
            <div class="body-loader8">
                <div class="container-loader8">
                    <div class="loader-loader8 loader8"></div>
                </div>
            </div>
        </>
    );
};

export default Loader;